
import Crown from "../../../assets/outline/Crown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CrownIcon({ className, dataTestid = "CrownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Crown data-testid={dataTestid} className={classes} {...rest} />
  );
}
